export const stateName = 'kyc';
export let FieldName;

(function (FieldName) {
  FieldName["FirstName"] = "first_name";
  FieldName["LastName"] = "last_name";
  FieldName["Birthdate"] = "birthdate";
  FieldName["SsnSerial"] = "ssn_serial";
  FieldName["PersonalIdNumber"] = "personal_id_number";
  FieldName["Address"] = "address";
  FieldName["IdentityDocument"] = "identity_document";
  FieldName["RegistrationNumber"] = "registration_number";
  FieldName["BusinessAddress"] = "business_address";
  FieldName["Ubo"] = "ubos";
})(FieldName || (FieldName = {}));